import React from 'react';

import { onConfirm as onConfirmAction } from '@r1-frontend/service-engineer-visit/actions';
import SubmitButton from '@r1-frontend/service-engineer-visit/components/SubmitButton';
import { useContextDispatch, useContextSelector } from '@r1-frontend/service-engineer-visit/hooks';
import getLoadingState from '@r1-frontend/service-engineer-visit/selectors/getLoadingState';
import getSelectedDate from '@r1-frontend/service-engineer-visit/selectors/getSelectedDate';
import { TGetTimeSlots } from '@r1-frontend/service-engineer-visit/types/TGetTimeSlots';
import { TReturnType } from '@r1-frontend/service-engineer-visit/types/TReturnType';

type TSubmitButtonContainerProps = {
    domain: string,
    onConfirm: (result: TReturnType | null, msg?: string) => void,
    onClickConfirm: () => void,
    getTimeSlotsFunc: TGetTimeSlots,
    productId?: number,
    gaLabel?: string,
}

const SubmitButtonContainer = ({ domain, onConfirm, onClickConfirm, getTimeSlotsFunc, productId, gaLabel }: TSubmitButtonContainerProps): JSX.Element => {
    const dispatch = useContextDispatch();
    const { selectedDate, loading } = useContextSelector(state => ({
        selectedDate: getSelectedDate(state),
        loading: getLoadingState(state),
    }));

    const handleConfirm = () => {
        dispatch(onConfirmAction(domain, onConfirm, getTimeSlotsFunc, productId, gaLabel));
        onClickConfirm();
    };

    const buttonIsDisabled = loading || !selectedDate || selectedDate && !(selectedDate.from && selectedDate.to);

    return (
        <SubmitButton
            selectedDate={selectedDate}
            handleConfirm={handleConfirm}
            buttonIsDisabled={buttonIsDisabled}
        />
    );
};

export default SubmitButtonContainer;
